import React from "react"

function LockPickReward() {
    return (
        <div id="lockPickReward">
            <h3><em>The NYPD officer takes a copy of the fingerprint.</em></h3>
            <h3 className="policeSpeech">"We'll get this analysed and let you know the results Larry."</h3>
            <h3><em>Larry wasn't listening, he was busy joining the dots.</em></h3>
            <h1 className="larrySpeech">"GLOVES!"</h1>
            <h3><em>Larry growls at the confused officer.</em></h3>
            <h3 className="larrySpeech">"Don't you see? One of the suspects always wears gloves. If she had taken the diamond there wouldn't have been a fingerprint to find."</h3>
            <h3><em>It looks like we can eliminate <mark className="yellowTab">Dorris Humphries</mark> from our investigation using the keypad below.</em></h3>
        </div>
    )
}

export default LockPickReward